import { createContext, useEffect, useState } from "react";
import {
  localStorageRemove,
  localStorageSave,
} from "../../../services/localStorageService";
import PropTypes from "prop-types";

import { useSnackBar } from "../../../hooks/useSnackBar";

const AircraftWarrantyContext = createContext();

const localStoragePrefix = "configuration/aircraft/warranty/draft";

const AircraftWarrantyProvider = ({
  aircraftId,
  children,
  newAircraft,
}) => {
 
 
  const [drafts, setDrafts] = useState(getSectionsByPrefix(localStoragePrefix));
  const [newDrafts, setNewDrafts] = useState({});
  const [loadingAircraft, setLoadingAircraft] = useState(false);
  const { successMsg, warningMsg, infoMsg } = useSnackBar();

 
  const confirmWarranty = (aircraftId) => {
    removeDraft(aircraftId, "row");
  };


  const resetWarranty = (aircraftId) => {
    if (aircraftId in newDrafts) {
      infoMsg("Draft discarded");
      removeDraft(aircraftId, "row");
    } else {
      removeDraft(aircraftId, "row");
    }
  };

  
  // Draft methods
  const saveDraft = (aircraftId, section, value) => {
    localStorageSave(
      `${localStoragePrefix}/${section}`,
      { id: aircraftId },
      value
    );
    setDrafts((prev) => ({
      ...prev,
      [aircraftId]: (prev[aircraftId] ?? new Set()).add(section),
    }));
  };
  const isWarrantyDraft = (id) => id in drafts;
  const isWarrantySectionDraft = (id, section) => drafts[id]?.has(section);
  const removeDraft = (aircraftId, section) => {
    localStorageRemove(`${localStoragePrefix}/${section}`, {
      id: aircraftId.toString(),
    });

    setDrafts((prev) => {
      // Copia el estado actual
      let prevDrafts = { ...prev };

      // Si existe el aircraftId, actualizamos sus secciones
      if (prevDrafts[aircraftId]) {
        let prevSet = new Set(prevDrafts[aircraftId]); // Clonamos el Set actual
        prevSet.delete(section); // Eliminamos la sección especificada

        if (prevSet.size > 0) {
          prevDrafts[aircraftId] = prevSet; // Actualizamos solo si quedan secciones
        } else {
          delete prevDrafts[aircraftId]; // Eliminamos el aircraftId si ya no tiene secciones
        }
      }

      return prevDrafts; // Retornamos el estado actualizado
    });
  };

 
  return (
    <AircraftWarrantyContext.Provider
      value={{
        saveDraft,
        removeDraft,
        loadingAircraft,
        resetWarranty,
        isWarrantyDraft,
        newDrafts,
        confirmWarranty,
        isWarrantySectionDraft
      }}
    >
      {children}
    </AircraftWarrantyContext.Provider>
  );
};
function getSectionsByPrefix(prefix) {
  return [...Array(localStorage.length).keys()]
    .map((i) => localStorage.key(i))
    .filter((key) => key.startsWith(prefix))
    .reduce((acc, key) => {
      const queryParams = new URLSearchParams(key.split("?")[1]);
      if (localStorage.getItem("u_id") === queryParams.get("userId")) {
        let id = queryParams.get("id");
        if (!acc[id]) {
          acc[id] = new Set();
        }
        acc[id].add(key.split("?")[0].replace(prefix + "/", ""));
      }
      return acc;
    }, {});
}

function getObjectsBySection(prefix, section) {
  return [...Array(localStorage.length).keys()]
    .map((i) => localStorage.key(i))
    .filter((key) => key.startsWith(prefix + "/" + section))
    .reduce((acc, key) => {
      const queryParams = new URLSearchParams(key.split("?")[1]);
      if (localStorage.getItem("u_id") === queryParams.get("userId")) {
        const id = queryParams.get("id");
        acc[id] = JSON.parse(localStorage.getItem(key));
      }
      return acc;
    }, {});
}

export { AircraftWarrantyContext, AircraftWarrantyProvider };
